import * as React from 'react';
import {Link} from 'react-router-dom';
import cx from 'classnames';
import IconLogo from './logo.inline.svg';
import style from './Logo.css';
import {animationData} from './animation';

let lottie;
if (typeof window !== 'undefined') {
    lottie = require('./lottie');
}

export const Logo = ({className}) => (
    <Link className={cx(style.root, className)} to="/">
        <IconLogo/>
    </Link>
);

export class AnimationLogo extends React.Component {
    componentDidMount() {
        const params = {
            container: this.container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData
        };

        lottie.loadAnimation(params);
    }

    render() {
        return (
            <div className={this.props.className} ref={c => this.container = c}>
                {typeof window === 'undefined' && <i/>}
            </div>
        );
    }
}